/* Warning surface, not danger: the attempt bucket closed, nothing failed. */
.notice {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 1rem;
  border: 1px solid var(--warning-text);
  border-radius: 0.375rem;
  background-color: var(--warning-surface);
  color: var(--warning-text);
}

.title {
  margin: 0;
  font-weight: 600;
}

.body {
  margin: 0;
  font-size: 0.875rem;
}

.countdown {
  margin: 0;
  font-variant-numeric: tabular-nums;
}
